import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import TokenStockForm from './TokenStockForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateXStock = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.tokenXstock,
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.xStocks.createSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          case 'TOKEN_METADATA_ALREADY_EXISTS':
            notify(t('module.xStocks.validate.conflict'), { type: 'error' });
            break;
          default:
            notify(t('module.xStocks.unknownError'), { type: 'error' });
            break;
        }
      },
    },
  });

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.xStocks.createToken')}</DialogTitle>
        <DialogContent>
          <TokenStockForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="x-stocks" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateXStock;
